import React, { useState } from 'react';

const CheckboxExample = () => {
  const [selectedItems, setSelectedItems] = useState([]);

  const handleCheckboxChange = (value) => {
    if (selectedItems.includes(value)) {
      setSelectedItems(selectedItems.filter(item => item !== value));
    } else {
      setSelectedItems([...selectedItems, value]);
    }
  };

  return (
    <div>
      <label>
        <input
          type="checkbox"
          checked={selectedItems.includes('Item 1')}
          onChange={() => handleCheckboxChange('Item 1')}
        />
        Item 1
      </label>
      <br />
      <label>
        <input
          type="checkbox"
          checked={selectedItems.includes('Item 2')}
          onChange={() => handleCheckboxChange('Item 2')}
        />
        Item 2
      </label>
      <br />
      <label>
        <input
          type="checkbox"
          checked={selectedItems.includes('Item 3')}
          onChange={() => handleCheckboxChange('Item 3')}
        />
        Item 3
      </label>
      <br />
      <label>
        <input
          type="checkbox"
          checked={selectedItems.includes('Item 4')}
          onChange={() => handleCheckboxChange('Item 4')}
        />
        Item 4
      </label>
      <br />

      <h3>Selected Items:</h3>
      <ul>
        {selectedItems.map(item => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default CheckboxExample;
